
//报价详情列
export const QuotationDetailColumn =[{
  type: 'checkbox',
  width: 60,
  title: '',
  align: 'center',
  fixed: 'left',
  resizable: true,
  drag: true
},
  // {
  //   type: 'selection',
  //   width: 60,
  //   align: 'center',
  //   fixed: 'left',
  //   // resizable: true,
  // },
  {
    type: 'checkbox',
    width: 60,
    title: '',
    align: 'center',
    fixed: 'left',
    resizable: true,
    drag: true,
    sum: false,
  },
  {
    title: '序号',
    key: 'seq',
    sortable: true,
    // sortMethod: (a, b) => {
    //   return a.seq.localeCompare(b.seq);
    // },
    fixed: 'left',
    align: 'center',
    minWidth: 90,
    maxWidth: 150,
    width: 90,
    resizable: true,
    checked: true,
    drag: true,
    sum: false,
    render: (h, {row}) => {
      if (this.form.status === '草稿') {
        return h('Input', {
          props: {
            type: 'number',
            value: row.seq,
          },
          class: 'qtcIpt seqIpt',
          on: {
            input: (value) => {
              row.seq = value;
              this.iptChange(row);
            },
          },
        });
      } else {
        return h('div', row.seq);
      }
    },
  },
  {
    title: '图片',
    key: 'pic',
    fixed: 'left',
    align: 'center',
    minWidth: 80,
    maxWidth: 150,
    width: 80,
    checked: true,
    resizable: true,
    drag: true,
    sum: false,
    render: (h, {row}) => {
      return h('el-image', {
        props: {
          src: row.pic,           // 图片地址
          fit: 'contain',      // 图片填充方式（contain/cover/fill/none/scale-down）
          previewSrcList: [row.pic], // 启用预览，并设置预览的图片列表
          zIndex: 9999,          // 调整预览层的 z-index（避免被遮挡）
        },
        style: {
          width: '100%',
          height: '100%',
          cursor: 'pointer',      // 鼠标悬停时显示手型
        },
      });
    },
  },
  {
    title: '客户询盘号',
    key: 'search_no',
    fixed: 'left',
    align: 'center',
    minWidth: 120,
    maxWidth: 150,
    width: 120,
    sortable: true,
    checked: true,
    resizable: true,
    drag: true,
    sum: false,
    render: (h, {row}) => {
      if (row.search_no) {
        return h('Tooltip', {
          props: {
            content: row.search_no,
            placement: 'top',
          },
        }, [
          h('div', {
            class: 'line-3',
            domProps: {
              innerHTML: row.search_no,
            },
          }),
        ]);
      }
      return h('div', row.search_no);
    },
  },
  {
    title: '自编号',
    key: 'my_no',
    fixed: 'left',
    align: 'center',
    minWidth: 120,
    maxWidth: 150,
    width: 120,
    sortable: true,
    checked: true,
    resizable: true,
    drag: true,
    sum: false,
    render: (h, {row}) => {
      const className = row.my_no === '虚拟库产品' ? 'redColor bold' : 'mainColor';
      return h('div', {
        class: `overflowBox ${className}`,
      }, row.my_no);
    },
  },
  {
    title: 'NID',
    key: 'rca_id',
    fixed: 'left',
    align: 'center',
    minWidth: 80,
    maxWidth: 150,
    width: 80,
    sortable: true,
    checked: true,
    resizable: true,
    drag: true,
    sum: false,
  },
  {
    title: 'OE',
    key: 'oe',
    minWidth: 120,
    maxWidth: 150,
    width: 120,
    resizable: true,
    sortable: true,
    fixed: 'left',
    checked: true,
    drag: true,
    sum: false,
  },
  {
    title: '名称',
    key: 'product_name',
    minWidth: 90,
    maxWidth: 150,
    width: 90,
    resizable: true,
    sortable: true,
    fixed: 'left',
    checked: true,
    drag: true,
    sum: false,
    render: (h, {row}) => {
      const className = row.product_name === '找不到产品' || row.product_name === '虚拟库产品'
        ? 'redColor bold'
        : 'mainColor';
      return h('div', {
        class: `overflowBox ${className}`,
      }, row.product_name);
    },
  },
  {
    title: '产品状态',
    key: 'pd_status',
    minWidth: 120,
    maxWidth: 150,
    width: 120,
    resizable: true,
    sortable: true,
    checked: true,
    fixed: 'left',
    drag: true,
    sum: false,
    render: (h, {row}) => {
      const className = row.pd_status === '已满足' ? 'mainColor' : 'redColor bold';
      return h('div', {
        class: `overflowBox ${className}`,
      }, row.pd_status);
    },
  },
  {
    title: '品牌',
    key: 'brand',
    minWidth: 80,
    maxWidth: 150,
    width: 80,
    resizable: true,
    sortable: true,
    fixed: 'left',
    checked: true,
    drag: true,
    sum: false,
  },
  {
    title: '车型',
    key: 'model',
    minWidth: 120,
    maxWidth: 150,
    width: 120,
    resizable: true,
    sortable: true,
    fixed: 'left',
    checked: true,
    drag: true,
    sum: false,
    render: (h, {row}) => {
      if (row.model) {
        return h('Tooltip', {
          props: {
            content: row.model,
            placement: 'top',
          },
        }, [
          h('div', {
            class: 'line-3',
          }, row.model),
        ]);
      }
      return h('div', row.model);
    },
  },
  {
    title: '规格',
    key: 'specification_cn',
    minWidth: 80,
    maxWidth: 150,
    width: 80,
    resizable: true,
    sortable: true,
    fixed: 'left',
    checked: true,
    drag: true,
    sum: false,
    render: (h, {row}) => {
      if (row.specification_cn) {
        return h('Tooltip', {
          props: {
            content: row.specification_cn,
            placement: 'top',
          },
        }, [
          h('div', {
            class: 'line-3',
          }, row.specification_cn),
        ]);
      }
      return h('div', row.specification_cn);
    },
  },
  {
    title: '汽车商',
    key: 'car_dealer',
    sortable: true,
    minWidth: 130,
    maxWidth: 150,
    width: 130,
    resizable: true,
    checked: true,
    drag: true,
    sum: false,
  },
  {
    title: '销售提醒',
    key: 'sale_remark',
    minWidth: 130,
    maxWidth: 150,
    width: 130,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
    render: (h, {row}) => {
      if (row.sale_remark) {
        return h('Tooltip', {
          props: {
            content: row.sale_remark,
            placement: 'top',
          },
        }, [
          h('div', {
            class: 'line-3 red_3',
          }, row.sale_remark),
        ]);
      }
      return h('div', row.sale_remark);
    },
  },
  {
    title: '错误订单提示',
    key: 'error_tips',
    sortable: true,
    minWidth: 130,
    maxWidth: 150,
    width: 130,
    resizable: true,
    checked: true,
    drag: true,
    sum: false,
    render: (h, {row}) => {
      if (row.error_tips) {
        return h('Tooltip', {
          props: {
            content: row.error_tips,
            placement: 'top',
          },
        }, [
          h('div', {
            class: 'line-3 red_3',
          }, row.error_tips),
        ]);
      }
      return h('div', row.error_tips);
    },
  },
  {
    title: '成套提醒',
    key: 'kit_tip',
    sortable: true,
    minWidth: 130,
    maxWidth: 150,
    width: 130,
    resizable: true,
    checked: true,
    drag: true,
    sum: false,
  },
  {
    title: '数量提示',
    key: 'num_tips',
    minWidth: 130,
    maxWidth: 150,
    width: 130,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
    render: (h, {row}) => {
      if (row.num_tips) {
        return h('Tooltip', {
          props: {
            content: row.num_tips,
            placement: 'top',
          },
        }, [
          h('div', {
            class: 'line-3 red_3',
          }, row.num_tips),
        ]);
      }
      return h('div', row.num_tips);
    },
  },
  {
    title: '整箱数量',
    key: 'box_qty',
    sortable: true,
    minWidth: 130,
    maxWidth: 150,
    width: 130,
    resizable: true,
    checked: true,
    drag: true,
    sum: false,
  },
  {
    title: '业务备注',
    key: 'notes',
    minWidth: 130,
    maxWidth: 150,
    width: 130,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
    render: (h, {row}) => {
      if (this.form.status === '草稿') {
        return h('Input', {
          props: {
            type: 'textarea',
            value: row.notes,
          },
          class: 'remarkIpt',
          on: {
            input: (value) => {
              row.notes = value;
              this.iptChange(row);
            },
          },
        });
      } else {
        return h('div', row.notes);
      }
    },
  },
  {
    title: '数量',
    key: 'quantity',
    sortable: true,
    minWidth: 130,
    maxWidth: 150,
    width: 130,
    resizable: true,
    align: 'right',
    checked: true,
    drag: true,
    sum: false,
    render: (h, {row}) => {
      if (this.form.status === '草稿') {
        return h('Input', {
          props: {
            type: 'number',
            value: row.quantity,
          },
          class: 'qtcIpt',
          on: {
            input: (value) => {
              row.quantity = value;
              this.iptChange(row);
            },
          },
        });
      } else {
        return h('div', row.quantity);
      }
    },
  },
  {
    title: '销售价',
    key: 'uprice',
    minWidth: 130,
    maxWidth: 150,
    width: 130,
    resizable: true,
    sortable: true,
    align: 'right',
    checked: true,
    drag: true,
    sum: false,
    render: (h, {row}) => {
      if (this.form.status === '草稿') {
        return h('Input', {
          props: {
            type: 'number',
            value: row.uprice,
            min: 0,
          },
          class: 'priceIpt',
          on: {
            input: (value) => {
              row.uprice = value;
              this.iptChange(row);
            },
          },
        });
      } else {
        return h('div', row.uprice);
      }
    },
  },
  {
    title: '备注',
    key: 'remark',
    minWidth: 130,
    maxWidth: 150,
    width: 130,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
    render: (h, {row}) => {
      if (this.form.status === '草稿') {
        return h('Input', {
          props: {
            type: 'textarea',
            value: row.remark,
          },
          class: 'remarkIpt',
          on: {
            input: (value) => {
              row.remark = value;
              this.iptChange(row);
            },
          },
        });
      } else {
        return h('div', row.remark);
      }
    },
  },
  {
    title: '客户打印号码',
    key: 'customer_print_no',
    minWidth: 140,
    maxWidth: 200,
    width: 140,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
  },
    {
    title: '产品打标详情',
    key: 'label_details',
    minWidth: 160,
    maxWidth: 170,
    width: 160,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
  },
  {
    title: '客户等级价',
    key: 'price',
    minWidth: 130,
    maxWidth: 150,
    width: 130,
    resizable: true,
    sortable: true,
    align: 'right',
    checked: true,
    drag: true,
    sum: false,
  },
    {
    title: '客户等级价(美元)',
    key: 'price_usd_rate',
    minWidth: 180,
    maxWidth: 190,
    width: 180,
    resizable: true,
    sortable: true,
    align: 'right',
    checked: true,
    drag: true,
    sum: false,
  },
      {
    title: '客户等级价(自定义)',
    key: 'price_rate1',
    minWidth: 180,
    maxWidth: 190,
    width: 180,
    resizable: true,
    sortable: true,
    align: 'right',
    checked: true,
    drag: true,
    sum: false,
  },

    {
    title: '总金额',
    key: 'totalprice',
    minWidth: 130,
    maxWidth: 150,
    width: 130,
    resizable: true,
    sortable: true,
    align: 'right',
    checked: true,
    drag: true,
    sum: false,
  },
  {
    title: '价格提示',
    key: 'price_tip',
    minWidth: 130,
    maxWidth: 150,
    width: 130,
    resizable: true,
    align: 'center',
    checked: true,
    drag: true,
    sum: false,
    render: (h, {row}) => {
      if (Number(row.price) !== 0) {
        let content = '';
        let className = '';
        if (row.uprice - row.min_selling_price < 0) {
          content = '低于最低售价';
          className = 'redColor';
        } else if (row.uprice - row.price > 0) {
          content = '高于等级价格';
          className = 'greenColor';
        } else if (row.uprice - row.price < 0) {
          content = '低于等级价格';
          className = 'redColor';
        }
        return h('div', {
          class: className,
        }, content);
      }
      return h('div');
    },
  },
  {
    title: '历史报价',
    key: 'last_quote_price',
    sortable: true,
    minWidth: 130,
    maxWidth: 150,
    width: 130,
    resizable: true,
    checked: true,
    drag: true,
    sum: false,
    render: (h, {row}) => {
      if (row.last_quote_info) {
        return h('Tooltip', {
          props: {
            content: row.last_quote_info,
            placement: 'top',
          },
        }, [
          h('div', {
            class: 'line-2',
            domProps: {
              innerHTML: row.last_quote_price,
            },
          }),
        ]);
      }
      return h('div', row.last_quote_price);
    },
  },
  {
    title: '最新交易价格',
    key: 'orders_price',
    sortable: true,
    minWidth: 130,
    maxWidth: 150,
    width: 130,
    resizable: true,
    checked: true,
    drag: true,
    sum: false,
  },
  // {
  //   title: '历史价格',
  //   key: 'price',
  //   minWidth: 130,
  //   maxWidth: 150,
  //   width: 130,
  //   resizable: true,
  //   sortable: true,
  //   checked: true,
  //   drag: true,
  //   sum: false,
  //   render: (h, { row }) => {
  //     if (row.last_orders) {
  //       return h('span', `于${this.$options.filters.formatDate(row.last_orders.create_date)},订${row.last_orders.quantity}`);
  //     }
  //     return h('span');
  //   },
  // },
  {
    title: '同国家历史价格',
    key: 'c_order_info',
    minWidth: 150,
    maxWidth: 150,
    width: 150,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
    render: (h, {row}) => {
      if (row.c_order_info) {
        return h('Tooltip', {
          props: {
            content: row.c_order_info,
            placement: 'top',
          },
        }, [
          h('div', {
            class: 'line-2',
            domProps: {
              innerHTML: row.c_order_info,
            },
          }),
        ]);
      }
      return h('div', row.c_order_info);
    },
  },
  {
    title: '最小起订量',
    key: 'min_qty',
    sortable: true,
    minWidth: 130,
    maxWidth: 150,
    width: 130,
    resizable: true,
    checked: true,
    drag: true,
    sum: false,
  },
  {
    title: '审核备注',
    key: 'audit_remark',
    minWidth: 130,
    maxWidth: 150,
    width: 130,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
    // hidden: !['已驳回', '已提交', '草稿', '已审核'].includes(this.form.status),
  },
  // {
  //   title: '审核状态',
  //   key: 'audit_state_txt',
  //   minWidth: 65,
  //   hidden: !['已驳回', '已提交'].includes(this.form.status),
  // },
  // {
  //   title: '审批人',
  //   key: 'audit_name',
  //   minWidth: 65,
  //   sortable: true,
  //   hidden: !['已驳回', '已提交'].includes(this.form.status),
  // },
  {
    title: '可用库存',
    key: 'stock_use',
    minWidth: 130,
    maxWidth: 150,
    width: 130,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
    render: (h, {row}) => {
      if (row.stock_used_txt) {
        return h('Tooltip', {
          props: {
            content: row.stock_used_txt,
            placement: 'top',
            effect: 'dark',
          },
        }, [
          h('div', row.stock_use),
        ]);
      }
      return h('div', row.stock_use);
    },
  },
  {
    title: '占用库存',
    key: 'stock_zhanyong',
    minWidth: 130,
    maxWidth: 150,
    width: 130,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
    render: (h, {row}) => {
      if (row.stock_zhanyong_txt) {
        return h('Tooltip', {
          props: {
            content: row.stock_zhanyong_txt,
            placement: 'top',
            effect: 'dark',
          },
        }, [
          h('div', {
            style: {
              fontWeight: 'bold',
            },
          }, row.stock_zhanyong),
        ]);
      }
      return h('div', row.stock_zhanyong);
    },
  },
  {
    title: '在途库存',
    key: 'stock_zaitu',
    minWidth: 130,
    maxWidth: 150,
    width: 130,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
    render: (h, {row}) => {
      if (row.stock_zaitu_txt) {
        return h('Tooltip', {
          props: {
            content: row.stock_zaitu_txt,
            placement: 'top',
            effect: 'dark',
          },
        }, [
          h('div', {
            style: {
              fontWeight: 'bold',
            },
          }, row.stock_zaitu),
        ]);
      }
      return h('span', row.stock_zaitu);
    },
  },
  {
    title: '通用库存',
    key: 'stock_tongyong',
    minWidth: 130,
    maxWidth: 150,
    width: 130,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
    render: (h, {row}) => {
      if (row.stock_tongyong) {
        return h('div', {
          domProps: {
            innerHTML: row.stock_tongyong,
          },
        });
      }
      return h('div');
    },
  },
  {
    title: '待检库存',
    key: 'stock_daijian',
    minWidth: 130,
    maxWidth: 150,
    width: 130,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
    render: (h, {row}) => {
      if (row.stock_daijian) {
        return h('div', {
          domProps: {
            innerHTML: row.stock_daijian,
          },
        });
      }
      return h('div');
    },
  },
  {
    title: '体积',
    key: 'volume',
    minWidth: 130,
    maxWidth: 150,
    width: 130,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
  },
  {
    title: '重量',
    key: 'weight',
    minWidth: 130,
    maxWidth: 150,
    width: 130,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
  },
  {
    title: '采购员',
    key: 'purchaser',
    minWidth: 130,
    maxWidth: 150,
    width: 130,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
  },
  {
    title: '操作',
    key: 'action',
    minWidth: 70,
    maxWidth: 150,
    resizable: true,
    align: 'center',
    fixed: 'right',
    width: 70,
    drag: true,
    sum: false,
    // hidden: form.status !== '草稿',
    render: (h, {row}) => {
      return h('Button', {
        props: {
          type: 'text',
          size: 'small',
        },
        on: {
          click: () => this.deleteLine(row, 'line'),
        },
      }, '删除');
    },
  },
]

// 订单详情列
export const OrderDetailColumns =  [{
  type: 'checkbox',
  width: 60,
  title: '',
  align: 'center',
  fixed: 'left',
  resizable: true,
  drag: true
},
  // {
  //   type: 'checkbox',
  //   width: 60,
  //   title: '',
  //   align: 'center',
  //   fixed: 'left',
  //   resizable: true,
  //   checked: true,
  //   drag: true,
  //   sum: false,
  // },
  {
    type: 'checkbox',
    width: 60,
    title: '',
    align: 'center',
    fixed: 'left',
    resizable: true,
    drag: true,
    sum: false,
  },
  {
    title: '序号',
    key: 'seq',
    sortable: true,
    fixed: 'left',
    align: 'center',
    minWidth: 90,
    maxWidth: 150,
    width: 90,
    resizable: true,
    checked: true,
    drag: true,
    sum: false,
  },
  {
    title: '图片',
    key: 'pic',
    fixed: 'left',
    align: 'center',
    minWidth: 110,
    maxWidth: 150,
    width: 110,
    checked: true,
    sortable: true,
    resizable: true,
    drag: true,
    sum: false,
    // render: (h, { row }) => {
    //   return h('el-image', {
    //     props: {
    //       src: row.pic,           // 图片地址
    //       fit: 'contain',      // 图片填充方式（contain/cover/fill/none/scale-down）
    //       previewSrcList: [row.pic], // 启用预览，并设置预览的图片列表
    //       zIndex: 9999,          // 调整预览层的 z-index（避免被遮挡）
    //     },
    //     style: {
    //       maxWidth: '100%',
    //       maxHeight: '100%',
    //       height: '120px',
    //       cursor: 'pointer',      // 鼠标悬停时显示手型
    //     },
    //   });
    // },
  },
  {
    title: 'NID',
    key: 'rca_id',
    fixed: 'left',
    align: 'center',
    minWidth: 110,
    maxWidth: 150,
    width: 110,
    sortable: true,
    checked: true,
    resizable: true,
    drag: true,
    sum: false,
  },
  {
    title: 'OE',
    key: 'oe',
    minWidth: 120,
    maxWidth: 150,
    width: 120,
    resizable: true,
    sortable: true,
    fixed: 'left',
    checked: true,
    drag: true,
    sum: false,
  },
  {
    title: '名称',
    key: 'product_name',
    minWidth: 90,
    maxWidth: 150,
    width: 90,
    resizable: true,
    sortable: true,
    fixed: 'left',
    checked: true,
    drag: true,
    sum: false,
    render: (h, {row}) => {
      const className = row.product_name === '找不到产品'
        ? 'redColor bold'
        : 'mainColor';
      return h('div', {
        class: `overflowBox ${className}`,
      }, row.product_name);
    },
  },
  {
    title: '品牌',
    key: 'brand_id',
    minWidth: 110,
    maxWidth: 150,
    width: 110,
    resizable: true,
    sortable: true,
    fixed: 'left',
    checked: true,
    drag: true,
    sum: false,
  },
  {
    title: '车型',
    key: 'rca_model',
    minWidth: 120,
    maxWidth: 150,
    width: 120,
    resizable: true,
    sortable: true,
    fixed: 'left',
    checked: true,
    drag: true,
    sum: false,
    // render: (h, { row }) => {
    //   if (row.rca_model) {
    //     return h('Tooltip', {
    //       props: {
    //         content: row.rca_model,
    //         placement: 'top',
    //       },
    //     }, [
    //       h('div', {
    //         class: 'line-3',
    //       }, row.rca_model),
    //     ]);
    //   }
    //   return h('div', row.rca_model);
    // },
  },
  {
    title: '规格',
    key: 'specification_cn',
    minWidth: 140,
    maxWidth: 150,
    width: 140,
    resizable: true,
    sortable: true,
    fixed: 'left',
    checked: true,
    drag: true,
    sum: false,
    // render: (h, { row }) => {
    //   if (row.specification_cn) {
    //     return h('Tooltip', {
    //       props: {
    //         content: row.specification_cn,
    //         placement: 'top',
    //       },
    //     }, [
    //       h('div', {
    //         class: 'line-3',
    //       }, row.specification_cn),
    //     ]);
    //   }
    //   return h('div', row.specification_cn);
    // },
  },
  {
    title: '搜索号',
    key: 'search_no',
    minWidth: 110,
    maxWidth: 150,
    width: 110,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
    // render: (h, { row }) => {
    //   if (row.search_no) {
    //     return h('Tooltip', {
    //       props: {
    //         content: row.search_no,
    //         placement: 'top',
    //       },
    //     }, [
    //       h('div', {
    //         class: 'line-3',
    //       }, row.search_no),
    //     ]);
    //   }
    //   return h('div', row.search_no);
    // },
  },
  {
    title: '品牌属性',
    key: 'pro_varchar6',
    minWidth: 110,
    maxWidth: 150,
    width: 110,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
    // render: (h, { row }) => {
    //   if (row.pro_varchar6) {
    //     return h('Tooltip', {
    //       props: {
    //         content: row.pro_varchar6,
    //         placement: 'top',
    //       },
    //     }, [
    //       h('div', {
    //         class: 'line-3',
    //       }, row.pro_varchar6),
    //     ]);
    //   }
    //   return h('div', row.pro_varchar6);
    // },
  },
  {
    title: '订单数量',
    key: 'quantity',
    minWidth: 130,
    maxWidth: 150,
    width: 130,
    resizable: true,
    checked: true,
    drag: true,
    sum: false,
    render: (h, {row}) => {
      if (this.form.status === '草稿') {
        return h('InputNumber', {
          props: {
            value: row.quantity,
          },
          class: 'qtcIpt',
          on: {
            input: (value) => {
              row.quantity = value;
              this.iptChange(row);
            },
          },
        });
      } else {
        return h('div', row.quantity);
      }
    },
  },
  {
    title: '自由分配数',
    key: 'zyfp_qty',
    minWidth: 150,
    maxWidth: 150,
    width: 150,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
    // render: (h, { row }) => {
    //   if (row.zyfp_qty) {
    //     return h('Tooltip', {
    //       props: {
    //         content: row.zyfp_qty,
    //         placement: 'top',
    //       },
    //     }, [
    //       h('div', {
    //         class: 'line-3',
    //       }, row.zyfp_qty),
    //     ]);
    //   }
    //   return h('div', row.zyfp_qty);
    // },
  },
  {
    title: '在途分配数',
    key: 'ztfp_qty',
    minWidth: 140,
    maxWidth: 150,
    width: 140,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
    // render: (h, { row }) => {
    //   if (row.ztfp_qty) {
    //     return h('Tooltip', {
    //       props: {
    //         content: row.ztfp_qty,
    //         placement: 'top',
    //       },
    //     }, [
    //       h('div', {
    //         class: 'line-3',
    //       }, row.ztfp_qty),
    //     ]);
    //   }
    //   return h('div', row.ztfp_qty);
    // },
  },
  {
    title: '可用库存',
    key: 'kykc',
    minWidth: 110,
    maxWidth: 150,
    width: 110,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
    // render: (h, { row }) => {
    //   if (row.kykc) {
    //     return h('Tooltip', {
    //       props: {
    //         content: row.kykc,
    //         placement: 'top',
    //       },
    //     }, [
    //       h('div', {
    //         class: 'line-3',
    //       }, row.kykc),
    //     ]);
    //   }
    //   return h('div', row.kykc);
    // },
  },
  {
    title: '赠品库存数',
    key: 'zpkcqty',
    minWidth: 140,
    maxWidth: 150,
    width: 140,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
    // render: (h, { row }) => {
    //   if (row.zpkcqty) {
    //     return h('Tooltip', {
    //       props: {
    //         content: row.zpkcqty,
    //         placement: 'top',
    //       },
    //     }, [
    //       h('div', {
    //         class: 'line-3',
    //       }, row.zpkcqty),
    //     ]);
    //   }
    //   return h('div', row.zpkcqty);
    // },
  },
  {
    title: '请购数量',
    key: 'qgfp_qty',
    minWidth: 110,
    maxWidth: 150,
    width: 110,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
    // render: (h, { row }) => {
    //   if (row.qgfp_qty) {
    //     return h('Tooltip', {
    //       props: {
    //         content: row.qgfp_qty,
    //         placement: 'top',
    //       },
    //     }, [
    //       h('div', {
    //         class: 'line-3',
    //       }, row.qgfp_qty),
    //     ]);
    //   }
    //   return h('div', row.qgfp_qty);
    // },
  },
  {
    title: '请购单号',
    key: 'purchase_requisition_no',
    minWidth: 110,
    maxWidth: 150,
    width: 110,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
    // render: (h, { row }) => {
    //   if (row.purchase_requisition_no) {
    //     return h('Tooltip', {
    //       props: {
    //         content: row.purchase_requisition_no,
    //         placement: 'top',
    //       },
    //     }, [
    //       h('div', {
    //         class: 'line-3',
    //       }, row.purchase_requisition_no),
    //     ]);
    //   }
    //   return h('div', row.purchase_requisition_no);
    // },
  },
  {
    title: '已备货数量',
    key: 'picking_qty',
    minWidth: 140,
    maxWidth: 150,
    width: 140,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
    // render: (h, { row }) => {
    //   if (row.picking_qty) {
    //     return h('Tooltip', {
    //       props: {
    //         content: row.picking_qty,
    //         placement: 'top',
    //       },
    //     }, [
    //       h('div', {
    //         class: 'line-3',
    //       }, row.picking_qty),
    //     ]);
    //   }
    //   return h('div', row.picking_qty);
    // },
  },
  {
    title: '已发货数量',
    key: 'zcqty',
    minWidth: 140,
    maxWidth: 150,
    width: 140,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
    // render: (h, { row }) => {
    //   if (row.zcqty) {
    //     return h('Tooltip', {
    //       props: {
    //         content: row.zcqty,
    //         placement: 'top',
    //       },
    //     }, [
    //       h('div', {
    //         class: 'line-3',
    //       }, row.zcqty),
    //     ]);
    //   }
    //   return h('div', row.zcqty);
    // },
  },
  {
    title: '出库单ID',
    key: 'outbound_order_id',
    minWidth: 110,
    maxWidth: 150,
    width: 110,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
    // render: (h, { row }) => {
    //   if (row.outbound_order_id) {
    //     return h('Tooltip', {
    //       props: {
    //         content: row.outbound_order_id,
    //         placement: 'top',
    //       },
    //     }, [
    //       h('div', {
    //         class: 'line-3',
    //       }, row.outbound_order_id),
    //     ]);
    //   }
    //   return h('div', row.outbound_order_id);
    // },
  },
  {
    title: '价格',
    key: 'price',
    minWidth: 110,
    maxWidth: 150,
    width: 110,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
    // render: (h, { row }) => {
    //   if (row.price) {
    //     return h('Tooltip', {
    //       props: {
    //         content: row.price,
    //         placement: 'top',
    //       },
    //     }, [
    //       h('div', {
    //         class: 'line-3',
    //       }, row.price),
    //     ]);
    //   }
    //   return h('div', row.price);
    // },
  },
  {
    title: '销售 折让金额',
    key: 'sale_discount',
    minWidth: 170,
    maxWidth: 170,
    width: 170,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
  },
  {
    title: '退货原因',
    key: 'return_policy',
    minWidth: 170,
    maxWidth: 170,
    width: 170,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
  },
  {
    title: '退货批次',
    key: 'batch_no',
    minWidth: 170,
    maxWidth: 170,
    width: 170,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
  },
  {
    title: '退货类型',
    key: 'return_type',
    minWidth: 170,
    maxWidth: 170,
    width: 170,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
  },
  {
    title: '客户等级价',
    key: 'uprice',
    minWidth: 140,
    maxWidth: 150,
    width: 140,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
    // render: (h, { row }) => {
    //   if (row.uprice) {
    //     return h('Tooltip', {
    //       props: {
    //         content: row.uprice,
    //         placement: 'top',
    //       },
    //     }, [
    //       h('div', {
    //         class: 'line-3',
    //       }, row.uprice),
    //     ]);
    //   }
    //   return h('div', row.uprice);
    // },
  },
      {
    title: '客户等级价(美元)',
    key: 'price_usd_rate',
    minWidth: 180,
    maxWidth: 190,
    width: 180,
    resizable: true,
    sortable: true,
    align: 'right',
    checked: true,
    drag: true,
    sum: false,
  },
      {
    title: '客户等级价(自定义)',
    key: 'price_rate1',
    minWidth: 180,
    maxWidth: 190,
    width: 180,
    resizable: true,
    sortable: true,
    align: 'right',
    checked: true,
    drag: true,
    sum: false,
  },
  {
    title: '出库数量',
    key: 'outbound_qty',
    minWidth: 170,
    maxWidth: 170,
    width: 170,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
  },
  {
    title: '出库单号',
    key: 'outbound_order_no',
    minWidth: 170,
    maxWidth: 170,
    width: 170,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
  },
  {
    title: '总价',
    key: 'total_price',
    minWidth: 110,
    maxWidth: 150,
    width: 110,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
    // render: (h, { row }) => {
    //   if (row.total_price) {
    //     return h('Tooltip', {
    //       props: {
    //         content: row.total_price,
    //         placement: 'top',
    //       },
    //     }, [
    //       h('div', {
    //         class: 'line-3',
    //       }, row.total_price),
    //     ]);
    //   }
    //   return h('div', row.total_price);
    // },
  },
  {
    title: '业务备注',
    key: 'notes',
    minWidth: 110,
    maxWidth: 150,
    width: 110,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
    render: (h, {row}) => {
      if (this.form.status === '草稿') {
        return h('Input', {
          props: {
            type: 'textarea',
            value: row.notes,
          },
          class: 'qtcIpt',
          on: {
            input: (value) => {
              row.notes = value;
              this.iptChange(row);
            },
          },
        });
      } else {
        return h('div', row.notes);
      }
    },
  },
  {
    title: '订单备注',
    key: 'remark',
    minWidth: 110,
    maxWidth: 150,
    width: 110,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
    render: (h, {row}) => {
      if (this.form.status === '草稿') {
        return h('Input', {
          props: {
            type: 'textarea',
            value: row.remark,
          },
          class: 'qtcIpt',
          on: {
            input: (value) => {
              row.remark = value;
              this.iptChange(row);
            },
          },
        });
      } else {
        return h('div', row.remark);
      }
    },
  },
  {
    title: '客户打印号码',
    key: 'customer_print_no',
    minWidth: 140,
    maxWidth: 200,
    width: 140,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
  },
    {
    title: '产品打标详情',
    key: 'label_details',
    minWidth: 160,
    maxWidth: 170,
    width: 160,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
  },
  {
    title: '计划交期',
    key: 'plan_delivery_date',
    minWidth: 110,
    maxWidth: 150,
    width: 110,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
    // render: (h, { row }) => {
    //   if (row.plan_delivery_date) {
    //     return h('Tooltip', {
    //       props: {
    //         content: row.plan_delivery_date,
    //         placement: 'top',
    //       },
    //     }, [
    //       h('div', {
    //         class: 'line-3',
    //       }, row.plan_delivery_date),
    //     ]);
    //   }
    //   return h('div', row.plan_delivery_date);
    // },
  },
    {
    title: '要求交期',
    key: 'send_date',
    minWidth: 240,
    maxWidth: 240,
    width: 240,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
  },
  {
    title: '最终计划交期',
    key: 'updated_delivery_date',
    minWidth: 140,
    maxWidth: 150,
    width: 140,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
  },
  {
    title: '计划备注',
    key: 'plan_remarks',
    minWidth: 110,
    maxWidth: 150,
    width: 110,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
    // render: (h, { row }) => {
    //   if (row.plan_remarks) {
    //     return h('Tooltip', {
    //       props: {
    //         content: row.plan_remarks,
    //         placement: 'top',
    //       },
    //     }, [
    //       h('div', {
    //         class: 'line-3',
    //       }, row.plan_remarks),
    //     ]);
    //   }
    //   return h('div', row.plan_remarks);
    // },
  },
  {
    title: '计划确认 状态',
    key: 'status',
    minWidth: 140,
    maxWidth: 150,
    width: 140,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
    // render: (h, { row }) => {
    //   if (row.status) {
    //     return h('Tooltip', {
    //       props: {
    //         content: row.status,
    //         placement: 'top',
    //       },
    //     }, [
    //       h('div', {
    //         class: 'line-3',
    //       }, row.status),
    //     ]);
    //   }
    //   return h('div', row.status);
    // },
  },
  {
    title: '行关闭原因',
    key: 'row_closing_reason',
    minWidth: 140,
    maxWidth: 150,
    width: 140,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
    // render: (h, { row }) => {
    //   if (row.row_closing_reason) {
    //     return h('Tooltip', {
    //       props: {
    //         content: row.row_closing_reason,
    //         placement: 'top',
    //       },
    //     }, [
    //       h('div', {
    //         class: 'line-3',
    //       }, row.row_closing_reason),
    //     ]);
    //   }
    //   return h('div', row.row_closing_reason);
    // },
  },
  {
    title: '行关闭 状态',
    key: 'row_status',
    minWidth: 140,
    maxWidth: 150,
    width: 140,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
    // render: (h, { row }) => {
    //   if (row.row_status) {
    //     return h('Tooltip', {
    //       props: {
    //         content: row.row_status,
    //         placement: 'top',
    //       },
    //     }, [
    //       h('div', {
    //         class: 'line-3',
    //       }, row.row_status),
    //     ]);
    //   }
    //   return h('div', row.row_status);
    // },
  },
  {
    title: '行审核 状态',
    key: 'audit_status',
    minWidth: 140,
    maxWidth: 150,
    width: 140,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
    // render: (h, { row }) => {
    //   if (row.row_status) {
    //     return h('Tooltip', {
    //       props: {
    //         content: row.row_status,
    //         placement: 'top',
    //       },
    //     }, [
    //       h('div', {
    //         class: 'line-3',
    //       }, row.row_status),
    //     ]);
    //   }
    //   return h('div', row.row_status);
    // },
  },
  {
    title: '金碟订单行id',
    key: 'fentryid',
    minWidth: 140,
    maxWidth: 150,
    width: 140,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
    // render: (h, { row }) => {
    //   if (row.fentryid) {
    //     return h('Tooltip', {
    //       props: {
    //         content: row.fentryid,
    //         placement: 'top',
    //       },
    //     }, [
    //       h('div', {
    //         class: 'line-3',
    //       }, row.fentryid),
    //     ]);
    //   }
    //   return h('div', row.fentryid);
    // },
  },
  {
    title: '体积',
    key: 'volume',
    minWidth: 140,
    maxWidth: 150,
    width: 140,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
    // render: (h, { row }) => {
    //   if (row.volume) {
    //     return h('Tooltip', {
    //       props: {
    //         content: row.volume,
    //         placement: 'top',
    //       },
    //     }, [
    //       h('div', {
    //         class: 'line-3',
    //       }, row.volume),
    //     ]);
    //   }
    //   return h('div', row.volume);
    // },
  },
  {
    title: '重量',
    key: 'weight',
    minWidth: 140,
    maxWidth: 150,
    width: 140,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
    // render: (h, { row }) => {
    //   if (row.weight) {
    //     return h('Tooltip', {
    //       props: {
    //         content: row.weight,
    //         placement: 'top',
    //       },
    //     }, [
    //       h('div', {
    //         class: 'line-3',
    //       }, row.weight),
    //     ]);
    //   }
    //   return h('div', row.weight);
    // },
  },
  {
    title: '采购员',
    key: 'purchaser',
    minWidth: 110,
    maxWidth: 150,
    width: 110,
    resizable: true,
    sortable: true,
    checked: true,
    drag: true,
    sum: false,
    // render: (h, { row }) => {
    //   if (row.purchaser) {
    //     return h('Tooltip', {
    //       props: {
    //         content: row.purchaser,
    //         placement: 'top',
    //       },
    //     }, [
    //       h('div', {
    //         class: 'line-3',
    //       }, row.purchaser),
    //     ]);
    //   }
    //   return h('div', row.purchaser);
    // },
  },
];
// UserConfigSave({
//   "user_config_module":"2120",
//   "config_name":"QUOTE_ITEMS_TABLE_HEADER",
//   "content":JSON.stringify(b)
// }).then(res => {
//   if(res.data.status===200){
//     this.$message.success(res.data.msg)
//     // this.filterMethodData()
//   }else{
//     this.$message.error('No Data')
//   }
// })

// this.filterMethodData()
// UserConfigSave({
//   "user_config_module":"2121",
//   "config_name":"QUOTE_ITEMS_TABLE_HEADER",
//   "content":JSON.stringify(b)
// }).then(res => {
//   if(res.data.status===200){
//     this.$message.success(res.data.msg)
//     // this.filterMethodData()
//   }else{
//     this.$message.error('No Data')
//   }
// })



// WEBPACK FOOTER //
// ./src/utils/columns.js